import { usePreviousRef } from './use-previous-ref';

export function usePrevious<T>(value: T, initialValue: T | null = null): T | null {
  return usePreviousRef(value, initialValue).current;
}
